import ThirdSection from './ThirdSection';

export default ThirdSection;
